import React, {Component, Fragment} from 'react'
import Breadcrumb from '../common/breadcrumb';
import Swal from "sweetalert2";
import {Helmet} from "react-helmet";
import {clear_auth, set_auth} from "../../reducers/Auth";
import {connect} from "react-redux";
import {ListAgenda} from "./list";
import {TourContext} from "../guideComponent/guideTourProvicer";

export class Add_agenda extends Component {
    static contextType = TourContext;
    constructor(props) {
        super(props);
        this.state = {
            prosesSimpan    : false,
            isLoading       : true,
            agenda_title    : '',
            agenda_note     : '',
            agenda_type     : '',
            agenda_date     : '',
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    simpanAgenda = () => {
        this.setState({
            prosesSimpan: true,
        })

        let form = {
            title          : this.state.agenda_title,
            note           : this.state.agenda_note,
            date           : this.state.agenda_date,
            type           : this.state.agenda_type,
        }

        this.props.request("agenda/add", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    Swal.fire({
                        title               : 'Berhasil!',
                        text                : response.message,
                        icon                : 'success',
                        showConfirmButton   : false,
                        timer               : 800,
                    })
                    this.props.history.push('/dashboard')
                }else if (response) {
                    Swal.fire({
                        title               : 'Gagal!',
                        text                : response.message,
                        icon                : 'warning',
                        showConfirmButton   : false,
                        timer               : 800,
                    })
                }
                this.setState({
                    prosesSimpan: false,
                })
            });
    }
    componentDidMount() {
        this.tourTimeout = setTimeout(() => {
            const tourSteps = [
                {
                    selector: '.agenda-add-input-title',
                    title: 'Agenda Title',
                    content: 'Ubah kolom ini untuk memperbarui judul agenda yang sudah ada.'
                },
                {
                    selector: '.agenda-add-input-note',
                    title: 'Agenda Note',
                    content: 'Ubah kolom ini untuk memperbarui catatan atau keterangan tambahan mengenai agenda.'
                },
                {
                    selector: '.agenda-add-input-date',
                    title: 'Agenda Date',
                    content: 'Ubah tanggal pelaksanaan agenda sesuai kebutuhan.'
                },
                {
                    selector: '.agenda-add-select-type',
                    title: 'Agenda Type',
                    content: 'Ubah tipe agenda jika diperlukan: Libur Nasional, Libur Perusahaan, atau Acara.'
                },
                {
                    selector: '.agenda-add-btn-simpan',
                    title: 'Simpan Perubahan',
                    content: 'Klik tombol ini untuk menyimpan perubahan data agenda. Pastikan semua kolom sudah diperbarui dengan benar sebelum menyimpan.'
                }
            ];

            const { setSteps, setCurrent, setActive } = this.context;
            setSteps(tourSteps);
            setCurrent(0);
            setActive(true);
        }, 500);
    }

    componentWillUnmount() {
        clearTimeout(this.tourTimeout);
    }

    render() {
        return (
                <Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Tambah Agenda Perusahaan - Presensi</title>
                        <meta name="description" content="Tambah Agenda Perusahaan" />
                    </Helmet>
                    <Breadcrumb title="Tambah Agenda" parent="Dashboard" parentLink="/dashboard"/>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card">
                                    <div className="card-body">
                                        <form className="needs-validation user-add" noValidate="">
                                            <div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Agenda Title</label>
                                                    <div>
                                                        <input type="text" name="agenda_title" className="form-control col-xl-8 col-md-7 agenda-add-input-title" placeholder="Agenda Title..." onChange={this.handleChange}/>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Agenda Note</label>
                                                    <div>
                                                        <input type="text" name="agenda_note" className="form-control col-xl-8 col-md-7 agenda-add-input-note" placeholder="Agenda Note..." onChange={this.handleChange}/>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{fontSize: "12px", color: "#143B5E"}}
                                                           className="mb-2 font-weight-bold">Agenda Date</label>
                                                    <input type="date" name="agenda_date"
                                                           className="form-control col-xl-8 col-md-7 agenda-add-input-date"
                                                           defaultValue={this.state.agenda_date}
                                                           onChange={this.handleChange}/>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{fontSize: "12px", color: "#143B5E"}}
                                                           className="mb-2 font-weight-bold">Agenda Type</label>
                                                    <div>
                                                        <select id="agenda_type" name="agenda_type"
                                                                className="form-control col-xl-8 col-md-7 agenda-add-select-type"
                                                                value={this.state.agenda_type}
                                                                onChange={this.handleChange}>
                                                            <option value="">Pilih Tipe</option>
                                                            <option value="liburnasional">libur nasional</option>
                                                            <option value="liburperusahaan">libur perusahaan</option>
                                                            <option value="acara">acara</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                        <div className="pull-right">
                                            {this.state.prosesSimpan === false ?
                                                <button type="button" className="btn btn-primary agenda-add-btn-simpan"
                                                        onClick={this.simpanAgenda}>Simpan</button>
                                                :
                                                <button type="button" className="btn btn-primary agenda-add-btn-simpan"><i
                                                    className="fa fa-refresh fa-spin"></i> Loading</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(Add_agenda);
